import { useEffect, useState } from "react";

import { Button } from "~/components/ui/button";
import { getHealth } from "~/lib/api";

type HealthState =
  | { status: "loading" }
  | {
      status: "ok";
      data: { status: string; version: string; commit: string; uptime: number };
    }
  | { status: "error"; message: string };

export default function RootRoute() {
  const [health, setHealth] = useState<HealthState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const result = await getHealth();
        if (cancelled) return;
        if (result.error || !result.data) {
          setHealth({
            status: "error",
            message: `API responded with ${result.response.status}`,
          });
          return;
        }
        setHealth({ status: "ok", data: result.data });
      } catch (err) {
        if (cancelled) return;
        setHealth({
          status: "error",
          message: err instanceof Error ? err.message : "Unknown error",
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background px-6 text-foreground">
      <h1 className="text-4xl font-semibold tracking-tight">HandoverPro</h1>
      <p className="max-w-md text-center text-sm text-muted-foreground">
        v1 scaffold — React Router v7 SPA, Tailwind, shadcn/ui, installable PWA.
      </p>
      <section
        className="rounded-md border border-border bg-card px-4 py-3 text-sm"
        aria-live="polite"
      >
        {health.status === "loading" && <span>Checking API…</span>}
        {health.status === "error" && (
          <span className="text-destructive">API: {health.message}</span>
        )}
        {health.status === "ok" && (
          <span>
            API OK — v{health.data.version} ({health.data.commit}), up {health.data.uptime}s
          </span>
        )}
      </section>
      <Button>Get started</Button>
    </main>
  );
}
